import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { LoadingScreen } from "./LoadingScreen";

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { isLoading, isAdmin } = useAuth();
  if (isLoading) return <LoadingScreen label="Checking access…" />;
  if (!isAdmin) return <Navigate to="/admin/login" replace />;
  return <>{children}</>;
}

export function RequireParent({ children }: { children: React.ReactNode }) {
  const { isLoading, user, isAdmin, isParent } = useAuth();
  if (isLoading) return <LoadingScreen label="Checking access…" />;
  if (!user) return <Navigate to="/parent/login" replace />;
  // Admins can also see parent dashboards (useful for support).
  if (!isParent && !isAdmin) return <Navigate to="/parent/login" replace />;
  return <>{children}</>;
}
